import {Action} from "redux";
import {ICustomerEntriesActionCreator} from "../action/customer_entries_action";

import {
    GetEntryProjectsByCustomerRequest,
} from "../request/entry_request";

interface ICustomerEntriesDispatcher {
    getEntryList(item: GetEntryProjectsByCustomerRequest): void;

}

class Dispatcher implements ICustomerEntriesDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ICustomerEntriesActionCreator) {

    }

    public getEntryList = (item: GetEntryProjectsByCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestGetEntryProjectsAction(item));
    };

}

const createCustomerEntriesDispatcher = (dispatch: (action: Action) => void, actionCreator: ICustomerEntriesActionCreator): ICustomerEntriesDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {ICustomerEntriesDispatcher, createCustomerEntriesDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_entries_dispatcher.ts